import {BaseResponseMessage} from "./base";

export namespace MaintenanceNamespace {
    export const COMMAND = 'maintenance_state';

    export interface State {
        /** ms epoch, когда непривилегированных отключат */
        disconnectAt: number;
        /** ms epoch на момент отправки — для поправки на часы клиента */
        serverTime: number;
        message?: string;
    }

    /** state === null — режим технических работ выключен. */
    export class Response extends BaseResponseMessage {
        constructor(readonly state: State | null) {
            super(COMMAND, 0, true);
        }
    }
}
